import { VesselNavAreasModelBase, NavAreasFeature, NavAreas } from './vessel-nav-areas-model';
import { NavAreasGeometry } from '../models/data/NavAreasGeometry';
import { RouteGeometry } from './voyage-routing-model';
import { CrossedGeometries } from '../utils/geometries-intersection';

export class VesselNavAreasModelImpl extends VesselNavAreasModelBase {    
    constructor() {
        super();
        this._navAreas = NavAreasGeometry.features;
    }

    get areas(): NavAreasFeature[] | null {
        return this._navAreas;
    }

    getCrossedNavAreas(route: RouteGeometry) : string {
        const crossedAreas : string[] = [];
        const navAreas = this._areasCrossedByRoute(route);

        navAreas.forEach(a => {
            // special case
            if (a.properties.id === "IB") {
                crossedAreas.push(`IB - Baltic Sea sub-area - Sweden`)
            } else {
                crossedAreas.push(`${a.properties.id} - ${a.properties.coordinator}`);
            }
        })
       
        crossedAreas.sort();
        
        return crossedAreas.join('\n');
    }

    private _navAreas: NavAreasFeature[] | null = null;

    private _areasCrossedByRoute(routeGeometry: RouteGeometry): NavAreasFeature[] {
        const result = CrossedGeometries(routeGeometry, this._navAreas!);
        return result;
    }
}